import { programmesData } from './programmes_data.js';

export const getProgrammeBySlug = (slug) => programmesData[String(slug)] || null;
export const getAllProgrammes = () => Object.values(programmesData);

const _calcProgrammeTotal = (p) => {
  if (p == null) return 0;
  if (typeof p.workflow_total === "number" && p.workflow_total >= 0) return p.workflow_total;
  if (Array.isArray(p.steps)) return p.steps.length;
  return 0;
};

const _calcProgrammeDone = (p) => {
  if (p == null) return 0;
  if (typeof p.workflow_completed === "number" && p.workflow_completed >= 0) return p.workflow_completed;
  if (Array.isArray(p.steps)) return p.steps.filter((s) => s.status === "completed").length;
  return 0;
};

export const hydrateProgramme = (p) => {
  if (!p) return null;

  const total = _calcProgrammeTotal(p);
  const done = _calcProgrammeDone(p);
  const progressPercent = total ? Math.round((done / total) * 100) : 0;

  return ({ ...p, workflow_total: total, workflow_completed: done, progressPercent });
};
